module.exports = __webpack_public_path__ + "assets/img/nW1.98ac7dd4.jpg";